module.exports = __webpack_public_path__ + "img/map.31c48d58.png";